/* Code to Show/Hide the PAM menus in the left navigation based on pamGen2 flag */
const MENU_TO_ALLOW_IF_PAM_ENABLED = ['assetsSessions', 'managePamServices'];
const MENU_TO_ALLOW_IF_PAM_DISABLED = [
  'privilegedAccess',
  'mySessions',
  'pastSessions',
  'managePamServices',
];

/**
 * A util function to filter out the Legacy Nav Bar based on feature flag enablement
 *
 * @function
 *
 * @param subMenuItem {String} key/id for a submenu item listing of a nav submenu
 * @param featureFlags {Object} an object for reading customer feature flags booleans
 */
export const filterNavSubMenuView = (subMenuItem, featureFlags) => {
  const { isPamGen2, isEmergencyRolesUser } = featureFlags;
  if (subMenuItem.id === 'request') {
      const allowedIds = isPamGen2 ? MENU_TO_ALLOW_IF_PAM_ENABLED : MENU_TO_ALLOW_IF_PAM_DISABLED;
      subMenuItem.submenu = subMenuItem.submenu.filter((ele) => allowedIds.includes(ele.id));
  }

  if (subMenuItem.id === 'requestEmergencyAccess') {
    if (!isEmergencyRolesUser) {
      subMenuItem.submenu = subMenuItem.submenu.filter((ele) => ele.id !== 'requestEmergencyRoles');
    }
  }
};
